<template>
  <v-data-table :headers="headers" :items="variables" item-key="id" :loading="loading" height="150" class="elevation-0 content" dense hide-default-footer single-select fixed-header></v-data-table>
</template>

<script>
import { api } from '../../../api/common/instances';

export default {
  props: {
    sql: Object,
  },
  data() {
    return {
      headers: [
        { text: 'Variable Name', value: 'name', sortable: false, width: '10%' },
        { text: 'Data Type', value: 'datatypeString', sortable: false, width: '15%' },
        { text: 'Value', value: 'valueString', sortable: false },
      ],
      variables: [],
      loading: false,
    };
  },
  watch: {
    async sql(value) {
      this.loading = true;
      ({ data: this.variables } = await api('/analysis/sqlviewer/bind-list', {
        params: {
          sampleTime: value.sampleTime,
          sstmId: value.sstmId,
          sqlId: value.sqlId,
          sqlChildNumber: value.sqlChildNumber,
          sessionSerial: value.sessionSerial,
        },
      }));
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
